import { IconElement } from '@wix/design-system';

type Size = 'small' | 'medium' | 'tiny';

export interface PatternsTheme {
  name?: string;
  containerLayout?: 'panel' | 'page';
  sizes: {
    medium?: Size;
    small?: Size;
  };
  loader?: {
    size?: Size;
  };
  toolbar: {
    item: {
      size?: Size;
    };
    button: {
      suffix?: IconElement;
    };
  };
  radioGroup: {
    spacing?: string;
  };
  rangePicker: {
    size?: 'small' | 'medium';
    zIndex?: number;
    width?: string | number;
  };
}
